import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../assets/css/pageNotFound.css';
function PageNotFound() {
  return (
    <div className="content_box">
      <div className="form_boxes page_not_found">
        <h4>404</h4>
        <h2>Page Not Found</h2>
        <p>
          The page you were looking for could not be found. It might have been
          removed, renamed, or did not exist in the first place.
        </p>
        <NavLink className="nav-link" to="/">
          Home
        </NavLink>
      </div>
    </div>
  );
}

export default PageNotFound;
